'use strict';

// http://262.ecma-international.org/5.1/#sec-9.11

module.exports = require('is-callable');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2024/IsCallable.js
// module id = 1469
// module chunks = 1